var dblclick_setup_ = function ($scope, toastr, map, $compile) {
    
    // This function returns the coordinate
    // conversion string in DD to DMS.
    function ddToDms(lat, lng) {

       var lat = lat;
       var lng = lng;
       var latResult, lngResult, dmsResult;

       lat = parseFloat(lat);  
       lng = parseFloat(lng);

       latResult = (lat >= 0)? 'N' : 'S';

       // Call to getDms(lat) function for the coordinates of Latitude in DMS.
       // The result is stored in latResult variable.
       latResult += getDms(lat);

       lngResult = (lng >= 0)? 'E' : 'W';

       // Call to getDms(lng) function for the coordinates of Longitude in DMS.
       // The result is stored in lngResult variable.
       lngResult += getDms(lng);

       // Joining both variables and separate them with a space.
       dmsResult = latResult + ' ' + lngResult;

       // Return the resultant string
       return dmsResult;
    }

    function getDms(val) {

      var valDeg, valMin, valSec, result;

      val = Math.abs(val);

      valDeg = Math.floor(val);
      result = valDeg + "º";

      valMin = Math.floor((val - valDeg) * 60);
      result += valMin + "'";

      valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
      result += valSec + '"';

      return result;
    }
    
    map.addListener('dblclick', function (event) {
        if ($scope.is('amarsul')) {
            var lat = event.latLng.lat();
            var lon = event.latLng.lng();
            
            toastr.success(ddToDms(lat, lon), lat.toFixed(6) + ', ' + lon.toFixed(6));
        }
    });
    
    
}

export default dblclick_setup_


// WEBPACK FOOTER //
// ./src/doubleclick/setup.js